import React, { FC } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import { IonModal, IonHeader, IonContent, IonFooter } from '@ionic/react'
import './index.scss'
import { reject } from '@dt/fe-utils/dist/lodash'

interface IProps {
  title?: string;
  content?: any;
  reject?: () => void;
  resolve?: () => void;
  btnType?: 'single' | 'choice';
  okText?: string;
  cancelText?: string;
}

const TipModal: FC<IProps> = (props: IProps) => {
  const {
    title,
    content,
    okText,
    resolve,
    reject,
    btnType = 'single',
    cancelText,
  } = props
  return (
    <IonModal
      cssClass='tip-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader className='modal-header'>
        <span>{title || i18n.t('mkt.common.prompt')}</span>
        <div className='close' data-cypid='tipModalClose' onClick={reject}>
          <i className='iconfont icon-close'></i>
        </div>
      </IonHeader>
      <IonContent className='modal-content'>
        <div className='modal-body'>
          {content || ''}
        </div>
      </IonContent>
      <IonFooter className='modal-footer'>
        {
          btnType === 'choice' &&
            <div className='btn cancel' data-cypid='tipModalClose' onClick={reject}>
              <span>{cancelText || i18n.t('common.cancel')}</span>
            </div>
        }
        <div className='btn confirm' data-cypid='tipModalConfirm' onClick={resolve}>
          <span>{okText || i18n.t('cart.ikonw')}</span>
        </div>
      </IonFooter>
    </IonModal>
  )
}

export default observer(TipModal)
